import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="dash-footer">
      <div>Krosifin by NeedCFO | Delhi · Mumbai · Bangalore · Hyderabad | DPIIT Recognised Startup</div>
      <div className="dash-footer-links">
        <Link to="/terms">Terms of Service</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy">Privacy Policy</Link>
        <span aria-hidden="true">·</span>
        <Link to="/disclaimer">Disclaimer</Link>
      </div>
    </footer>
  );
}

export default Footer;
